import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.dl{box-shadow:0px 0px 15px 0px rgba(0, 0, 0, 0.15);}.ssr-plugin'
import '.ak{border-radius:1.25rem;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.dm{overflow-y:hidden;}.ssr-plugin'
import '.dn{padding:1rem 1.5rem;}.ssr-plugin'
import '.do{background:var(--palette-white);}.ssr-plugin'
import '.ag{justify-content:space-between;}.ssr-plugin'
import '.d{gap:1rem;}.ssr-plugin'
import '.dp{padding:0rem 1.5rem 2rem;}.ssr-plugin'
import '.dq{max-height:80vh;}.ssr-plugin'
import '.br{overflow-y:auto;}.ssr-plugin'
import '.bt{justify-content:flex-end;}.ssr-plugin'
import { styled } from 'inlines'
import { ReactNode } from 'react'
import { Button } from '@app/components/core/button/Button'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { useTranslations } from '@i18n/useLanguage'
import { ModalWrapper } from './ModalWrapper'
import useMediaQuery from '@app/util/useMediaQuery'

export type ModalProps = {
  children: ReactNode
  isOpen: boolean
  title?: string
  loading?: boolean
  renderContainer?: HTMLElement
  onClose: () => void
  onConfirm?: () => void
  backLabel?: string
  confirmLabel?: string
}

export const Modal = ({
  children,
  isOpen,
  loading,
  title,
  renderContainer,
  onClose,
  onConfirm,
  backLabel,
  confirmLabel,
}: ModalProps) => {
  // Always call hooks first
  const translations = useTranslations().app.common
  const isMobile = useMediaQuery()
  // Early return after hooks
  if (!isOpen) {
    return null
  }
  const content = (
    <div className="a b r dl ak v dm"
      style={{
        maxWidth: isMobile ? '90vw' : 'var(--max-width-modal)',
      }}
    >
      <div className="a dn do ag d"
      >
        <Title.H5>{title ?? translations.attention}</Title.H5>
        <CloseButton onClick={onClose} size="small" />
      </div>
      <div className="a b dp do dq br"
      >
        {children}
      </div>
      <div className="a dn do bt d"
      >
        <Button
          label={backLabel ?? translations.back}
          onClick={onClose}
          variant="secondary"
        />
        {onConfirm && (
          <Button
            label={confirmLabel ?? translations.continue}
            onClick={onConfirm}
            disabled={loading}
          />
        )}
      </div>
    </div>
  )

  return (
    <ModalWrapper renderContainer={renderContainer} onClose={onClose}>{content}</ModalWrapper>
  )
}
